import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import {
    Row,
    Col,
    Form,
    FormGroup,
    InputGroup,
    Input,
    Button,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
} from "reactstrap";
import { getRecords, saveRecords } from '../../services/api.service';

import { Link } from "react-router-dom";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

//Import i18n
import { withTranslation } from "react-i18next";

//Import Megamenu
import MegaMenu from "./MegaMenu";

// Redux Store
import { toggleRightSidebar } from "../../store/actions";

//Import logo Images
import logosmdark from "../../assets/images/logo-sm-dark.png";
import logodark from "../../assets/images/logo-dark.png";
import logosmlight from "../../assets/images/logo-sm-light.png";
import logolight from "../../assets/images/logo-light.png";

import gmlogo from "../../assets/images/LA-logo_AJ.png";
import gmlogosm from "../../assets/images/LogicAbsolute-48x48.png";

//Import Social Profile Images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

const Header = ({ toggleRightSidebar, toggleMenuCallback }) => {
    
     // State for search dropdown toggle
     const [isSearch, setIsSearch] = useState(false);
     // State for social profile dropdown toggle
     const [isSocialPf, setIsSocialPf] = useState(false);
     const [orgImg, setOrgImg] = useState("");
     const [loadingData, setLoadingData] = useState(true);

     const getOrgLogoData = async (id) => {
        try {
          let payload = {
            modelName: "organization_masters",
            whereCondition: {
              id: id, // Pass organization ID dynamically
            },
          };
    
          const responseData = await getRecords("/common/getRecords", payload);
          console.log("data for response ===>", responseData);
          
          if (responseData) {
            const data = responseData.data[0];
            console.log("logo data===>",data.organization_logo);
            
            if (data.organization_logo) {
              setOrgImg(`${process.env.REACT_APP_API_TESTING_PMS}uploads/organization-logo/${data.organization_logo}`);
            }
          }
        } catch (error) {
          console.error("Error fetching organization data:", error);
        } finally {
          setLoadingData(false);
        }
      };

      const getVendorData = async () => {
        try {
          const vendorId = localStorage.getItem("vendorId"); // Retrieve vendorId from local storage
          console.log("vendor id-===>", vendorId);
          
          let payload = {
            modelName: "vendor_masters",
            whereCondition: {
                id: vendorId,
            },
          };
    
          const responseData = await getRecords("/common/getRecords", payload);
          
          if (responseData.data && responseData.data.length > 0) {
            const data = responseData.data[0]; // Access the first index
            console.log("data from vendor master===>", data);
            console.log("organization_id===>", data.organization_id); // Log organization_id
            getOrgLogoData(data.organization_id)
        }
        } catch (error) {
          console.error("Error fetching organization data:", error);
        } finally {
          setLoadingData(false);
        }
      };
      useEffect(() => {
        getVendorData();

      }, []);
    
    /**
     * Toggle sidebar
     */
    const toggleMenu = () => {
        toggleMenuCallback();
    };

    

    /**
     * Toggles the sidebar
     */
    // toggleRightbar() {
    //     this.props.toggleRightSidebar();
    // }


    /**
     * Toggle fullscreen mode
     */
    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    };

    return (
        <header id="page-topbar">
            <div className="navbar-header">
                <div className="d-flex">
                    {/* Logo Section */}
                    <div className="navbar-brand-box">
                        <Link to="#" className="logo logo-dark">
                            <span className="logo-sm">
                                <img src={gmlogosm} alt="" height="40" />
                            </span>
                            <span className="logo-lg">
                                <img src={gmlogo} alt="" height="60" />
                            </span>
                        </Link>
                        <Link to="#" className="logo logo-light">
                            <span className="logo-sm">
                                <img src={gmlogosm} alt="" height="40" />
                            </span>
                            <span className="logo-lg">
                                <img src={gmlogo} alt="" height="60" />
                            </span>
                        </Link>
                    </div>
                    {/* Toggle Menu Button */}
                    <Button
                        size="sm"
                        color="none"
                        type="button"
                        onClick={toggleMenu}
                        className="px-3 font-size-24 header-item waves-effect"
                        id="vertical-menu-btn"
                    >
                        <i className="ri-menu-2-line align-middle"></i>
                    </Button>
                </div>
                <div className="ms-auto d-flex align-items-center">
                    {loadingData ? (
                        <p>Loading...</p>
                    ) : orgImg ? (
                        <img width="60" className="ms-3" src={orgImg} alt="" />
                    ) : (
                        <p></p>
                    )}
                </div>

                <div className="d-flex">
                    {/* Profile Menu */}
                    <ProfileMenu />
                </div>
            </div>
        </header>
    );
};

//     render() {
//         return (
//             <React.Fragment>
//                 <header id='page-topbar'>
//                     <div className='navbar-header'>
//                         <div className='d-flex'>
//                             <div className='navbar-brand-box'>
//                                 <Link to='#' className='logo logo-dark'>
//                                     <span className='logo-sm'>
//                                         <img
//                                             src={gmlogosm}
//                                             className='mr-2'
//                                             alt=''
//                                             height='40'
//                                         />
//                                     </span>
//                                     <span className='logo-lg'>
//                                         <img src={gmlogo} alt='' height='60' />
//                                     </span>
//                                 </Link>
                                
//                                 <Link to='#' className='logo logo-light'>
//                                     <span className='logo-sm'>
//                                         <img
//                                             src={gmlogosm}
//                                             alt=''
//                                             height='40'
//                                         />
//                                     </span>
//                                     <span className='logo-lg'>
//                                         <img src={gmlogo} alt='' height='60' />
//                                     </span>
//                                 </Link>
//                             </div>

//                             <Button
//                                 size='sm'
//                                 color='none'
//                                 type='button'
//                                 onClick={this.toggleMenu}
//                                 className='px-3 font-size-24 header-item waves-effect'
//                                 id='vertical-menu-btn'
//                             >
//                                 <i className='ri-menu-2-line align-middle'></i>
//                             </Button>

//                             {/* <Form className="app-search d-none d-lg-block">
//                                 <div className="position-relative">
//                                     <Input type="text" className="form-control" placeholder={this.props.t('Search')} />
//                                     <span className="ri-search-line"></span>
//                                 </div>
//                             </Form>

//                             <MegaMenu /> */}
//                         </div>

//                         <div className='d-flex'>
//                             {/* <div className="dropdown d-inline-block d-lg-none ms-2">
//                                 <button type="button" onClick={() => { this.setState({ isSearch: !this.state.isSearch }); }} className="btn header-item noti-icon waves-effect" id="page-header-search-dropdown">
//                                     <i className="ri-search-line"></i>
//                                 </button>
//                                 <div className={this.state.isSearch === true ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show" : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"}
//                                     aria-labelledby="page-header-search-dropdown">

//                                     <Form className="p-3">
//                                         <FormGroup className="m-0">
//                                             <InputGroup>
//                                                 <Input type="text" className="form-control" placeholder={this.props.t('Search')} />
//                                                 <div className="input-group-append">
//                                                     <Button color="primary" type="submit"><i className="ri-search-line"></i></Button>
//                                                 </div>
//                                             </InputGroup>
//                                         </FormGroup>
//                                     </Form>
//                                 </div>
//                             </div> */}

//                             {/* <LanguageDropdown /> */}

//                             {/* <Dropdown isOpen={this.state.isSocialPf} toggle={() => this.setState({ isSocialPf: !this.state.isSocialPf })} className="d-none d-lg-inline-block ms-1">
//                                 <DropdownToggle tag="button" className="btn header-item noti-icon waves-effect">
//                                     <i className="ri-apps-2-line"></i>
//                                 </DropdownToggle>
//                                 <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
//                                     <div className="px-lg-2">
//                                         <Row className="g-0">
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={github} alt="Github" />
//                                                     <span>{this.props.t('GitHub')}</span>
//                                                 </Link>
//                                             </Col>
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={bitbucket} alt="bitbucket" />
//                                                     <span>{this.props.t('Bitbucket')}</span>
//                                                 </Link>
//                                             </Col>
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={dribbble} alt="dribbble" />
//                                                     <span>{this.props.t('Dribbble')}</span>
//                                                 </Link>
//                                             </Col>
//                                         </Row>

//                                         <Row className="g-0">
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={dropbox} alt="dropbox" />
//                                                     <span>{this.props.t('Dropbox')}</span>
//                                                 </Link>
//                                             </Col>
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={mail_chimp} alt="mail_chimp" />
//                                                     <span>{this.props.t('Mail Chimp')}</span>
//                                                 </Link>
//                                             </Col>
//                                             <Col>
//                                                 <Link className="dropdown-icon-item" to="#">
//                                                     <img src={slack} alt="slack" />
//                                                     <span>{this.props.t('Slack')}</span>
//                                                 </Link>
//                                             </Col>
//                                         </Row>
//                                     </div>
//                                 </DropdownMenu>
//                             </Dropdown> */}

//                             {/* <div className="dropdown d-none d-lg-inline-block ms-1">
//                                 <Button color="none" type="button" className="header-item noti-icon waves-effect" onClick={this.toggleFullscreen}>
//                                     <i className="ri-fullscreen-line"></i>
//                                 </Button>
//                             </div> */}

//                             {/* <NotificationDropdown /> */}

//                             <div>
//                                 <img></img>    
//                             </div>   


//                             <ProfileMenu />

//                             {/* This code is required in future... */}

//                             {/* <div className="dropdown d-inline-block">
//                                 <Button color="none" onClick={this.toggleRightbar} type="button" className="header-item noti-icon right-bar-toggle waves-effect">
//                                     <i className="ri-settings-2-line"></i>
//                                 </Button>
//                             </div> */}
//                         </div>
//                     </div>
//                 </header>
//             </React.Fragment>
//         );
//     }
// }

const mapStateToProps = (state) => {
    const { layoutType } = state.Layout;
    return { layoutType };
};

export default connect(mapStateToProps, { toggleRightSidebar })(withTranslation()(Header));